<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item" v-if="lightMode" @click="setLightMode(false)" style="cursor: pointer;">
          <span>Tamna Tema</span>
        </li>
        <li class="nav-item" v-else @click="setLightMode(true)" style="cursor: pointer;">
          <span>Svetla Tema</span>
        </li>
      </ul>
      <div class="copyright">
        © {{year}}
        <a href="https://www.terraaqua.rs" target="_blank">Terra Aqua</a>
        All Rights Reserved
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      lightMode: true
    };
  },
  methods: {
    setLightMode(val) {
      this.lightMode = val;
      if(val) document.body.classList.add('white-content');
      else document.body.classList.remove('white-content');
      localStorage.setItem('lightMode', val.toString())

    }
  },
  mounted(){
    let savedLightMode =  localStorage.getItem('lightMode') || 'true'
    if (savedLightMode === 'true') this.setLightMode(true);
    else this.setLightMode(false);
  }
};
</script>
<style scoped>
  a.nav-link,
  .copyright{
    font-size: 17px!important;
  }
</style>
